import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22Ancizar_Serif%22,%22arguments%22:[{%22subsets%22:[%22latin%22],%22weight%22:[%22500%22,%22600%22],%22variable%22:%22--font-ancizar-serif%22,%22display%22:%22swap%22,%22adjustFontFallback%22:false}],%22variableName%22:%22ancizarSerif%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Ancizar Serif'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
